import { FlagDownConstants } from './FlagDownConstants'

export class FlagDownHelper {
  public static calculateFlagdownPostMatchFlexibility(
    scheduledPickupTs: number,
    scheduledDropoffTs: number,
    minTravelDuration: number,
  ): number {
    const actualTravelDuration = scheduledDropoffTs - scheduledPickupTs
    return actualTravelDuration - minTravelDuration + FlagDownConstants.FLAG_DOWN_POST_MATCH_TRAVEL_DURATION_FLEXIBILITY
  }
}
